import { render, staticRenderFns } from "./ServiceStat.vue?vue&type=template&id=565e1495&scoped=true&"
import script from "./ServiceStat.vue?vue&type=script&lang=js&"
export * from "./ServiceStat.vue?vue&type=script&lang=js&"
import style0 from "./ServiceStat.vue?vue&type=style&index=0&id=565e1495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e1495",
  null
  
)

export default component.exports